import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './styles.module.scss'
import Button from '../../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getExcerptReportData, getReportData, getReportsList, getXLSX, setInitialValues } from '../../../../actions/reports'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'
import cn from 'classnames'
import Loader from '../../../../components/Loader'
import { getCertificationRegisterGukReport, getDecreeGuk, getExcerptDecreeGuk, getProtocolGuk } from './DocCreaters'
import { getWordExcerptDecree, getWordDecree, getWordProtocol, getWordRegisterGuk  } from './WordCreaters'
import moment from 'moment'
import { FaRegFileWord } from "react-icons/fa";
import { saveAs } from 'file-saver'
import Modal from 'react-responsive-modal'
import { getOrganizations } from '../../../../actions/auth'
import { getCurrentCommission } from '../../../../utils/smallHelpers'


const REPORT_NAMES = [
  {name: 'Приказ', value: 'decree_guk', word: true},
  {name: 'Выписка из приказа', value: 'excerpt_decree_guk', word: true},
  {name: 'Реестр педагогических работников', value: 'certification_register_guk', word: true},
  {name: 'Протокол', value: 'protocol_guk', word: true},
]


export default function ReportsGUK () {
  
  const dispatch = useDispatch()
  const { userInfo } = useSelector(state => state.auth)
  const { certificationPeriods } = useSelector(state => state.common)
  const { name, data, loading, commission_id } = useSelector(state => state.reports)

  const popUpRef = useRef(null)

  const [popUpOpen, setPopUpOpen] = useState(false)
  const [reportName, setReportName] = useState('')
  const [wordDoc, setWordDoc] = useState(false)
  const [excerptMode, setExcerptMode] = useState(false)


  const comission = useMemo(() => getCurrentCommission(certificationPeriods, commission_id), [commission_id, certificationPeriods])

  useOnClickOutside(popUpRef, () => setPopUpOpen(false))

  useEffect(() => {
    dispatch(getReportsList())
  }, [])

  useEffect(() => {
    if (name !== reportName) return;
    const { callback, title } = getReportProps(reportName)
    createPdfDoc(callback, title)
    setPopUpOpen(false)
    setReportName('')
    setWordDoc(false)
    dispatch(setInitialValues())
  }, [reportName, data])
    
  const getExcerptData = async (orgId) => {
    setReportName('excerpt_decree_guk')
    await dispatch(getExcerptReportData(orgId))
  }

  const getCurrentReport = (value) => async () => {
    if (value === 'excerpt_decree_guk') return setExcerptMode(true);
    setReportName(value)
    await dispatch(getReportData(value))
  }

  const getReportProps = (reportName) => {
    let callback, title
    switch (reportName) {
      case 'certification_register_guk':
        callback = wordDoc ? getWordRegisterGuk : getCertificationRegisterGukReport
        break;
      case 'protocol_guk':
        callback = wordDoc ? getWordProtocol : getProtocolGuk
        break;
      case 'decree_guk':
        callback = wordDoc ?  getWordDecree : getDecreeGuk
        break;
      case 'excerpt_decree_guk':
        callback = wordDoc ? getWordExcerptDecree : getExcerptDecreeGuk
        break;
      default:
        callback = getProtocolGuk
        break;
    }
    title = REPORT_NAMES.find(report => report.value === reportName)?.name
    return { callback, title }
  }

  const createPdfDoc = async (createDataCB, title) => {
    const doc = await createDataCB({data, comission, userInfo})
    wordDoc ? saveAs(doc, `${title}`) : doc.save(`${title}.pdf`)
  }

  const togglePopUp = () => setPopUpOpen(!popUpOpen)

  const renderLi = (i) => (
    <li onClick={getCurrentReport(i.value)}>
      {i.name}
      {i.word && <FaRegFileWord onClick={() => setWordDoc(true)} color='#376fb9'/>}
    </li>
  )

  const certificationRegisterTable = () => (
      <table  hidden id='certificationRegisterTable'>
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>№ п/п по ДОУ</th>
            <th>Наименование образовательного учреждения</th>
            <th>ФИО аттестуемого</th>
            <th>Категория по заявлению</th>
            <th>Должность</th>
            <th>Месяц проведения аттестации</th>
            <th>Количество баллов по портфолио / награды</th>
            <th>Примечание/Отметка о поступлении</th>
          </tr>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>9</td>
          </tr>
        </thead>
        <tbody>
          {data && Object.keys(data).map((orgName, index) => {
            const reqCount = data[orgName].length
            const groupIndex = Object.values(data).slice(0, index).reduce((accum, group) => accum + group.length, 0)
            return (
              <>
                {data[orgName].map((req, index) => {
                  const attestationDate = req.attestation_date && moment(req.attestation_date).format('MMMM YYYY')
                  const completed = req.is_custom_status ? '+' : ''
                  const pointsAwards = req.simple_cert ? req.awards?.map(({name}) => name).join(', ') : req.user_points
                  
                  return (
                    <tr>
                      <td>{groupIndex + index + 1}</td>
                      <td>{index + 1}</td>
                      {!index && <td rowSpan={reqCount}>{orgName}</td>}
                      <td>{req.full_user_name}</td>
                      <td>{req.category}</td>
                      <td>{req.attestation_name}</td>
                      <td>{attestationDate}</td>
                      <td>{pointsAwards}</td>
                      <td>{completed}</td>
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={9}>{`Итого: ${reqCount} педагогических работника`}</td>
                </tr>
              </>
            )
          })}
        </tbody>
      </table>
  )

  return (
    <div ref={popUpRef} className={styles.popUpWrap}>

      <Button label={"Отчеты ДВО"} onClick={togglePopUp}/>

      <ul className={cn(styles.popUp, {[styles.popUpOpen]: popUpOpen})}>
        {loading ? <Loader wrapperStyle={{marginTop: '0'}}/> : REPORT_NAMES.map(renderLi)}
      </ul>

      {name === 'certification_register_guk' && certificationRegisterTable()}

      <SchoolsModal
        open={excerptMode}
        closeModal={() => setExcerptMode(false)}
        getExcerptData={getExcerptData}
      />

    </div>
  )
}


const SchoolsModal = ({open, closeModal, getExcerptData}) => {
  
  const dispatch = useDispatch()
  const { organizations } = useSelector(state => state.auth)

  useEffect(() => {
    dispatch(getOrganizations())
  }, [])
  
  const onRowClick = (org) => () => {
    getExcerptData(org)
    closeModal()
  }

  return (
    <Modal
      classNames={{ modal: styles.schoolsModal}}
      showCloseIcon={false}
      open={open}
      onClose={closeModal}
    >
      <ul>
        {organizations.map(org => (
          <li key={org.idOrganization} onClick={onRowClick(org.idOrganization)}>{org.OrgName}</li>
        ))}
      </ul>
    </Modal>
  )
}